import React, {useState, useEffect} from 'react';
import {PageHeader, Tabs, DatePicker, message, Input, Button} from 'antd';
import StatisticChart from '@/page/customer/StatisticPage/StatisticChart';
import dayjs from 'dayjs';
import styles from '@/page/conversation/ConPage/Content/card.module.less';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import CustomerStatistic from '@/page/customer/StatisticPage/CustomerStatistic';

const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

const dateFormat = 'YYYY-MM-DD';
export default function StatisticPage() {
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const [end, setEnd] = useState(dayjs().subtract(1, 'days').format(dateFormat));
    const [start, setStart] = useState(dayjs().subtract(30, 'days').format(dateFormat));
    const [s, setS] = useState(null);
    const [type, setType] = useState('num');
    const [searchParams, setSearchParams] = useState({
        startTime: new Date(start).getTime() / 1000,
        endTime: new Date(end).getTime() / 1000,
        userId: userId,
        s: null,
    });
    useEffect(() => {
        initData();
    }, [start, end]);

    function initData() {
        let temp = {...searchParams};
        temp.startTime = new Date(start).getTime() / 1000;
        temp.endTime = new Date(end).getTime() / 1000;
        temp.s = s;
        setSearchParams(temp);
    }

    function changeTab(key) {
        setType(key);
    }

    function changeName(e) {
        setS(e.target.value);
    }

    function changeDate(date, dateStr) {
        if (dateStr[0] === '' || dateStr[1] === '') {
            message.error('请选择正确的时间');
            return;
        } else {
            // 开始时间和结束时间不能超过29天，
            const day = dayjs(date[1]).diff(dayjs(date[0]), 'days');
            if (day > 30) {
                message.error('日期选择不能超过30天');
                return;
            }
            setStart(dateStr[0]);
            setEnd(dateStr[1]);
        }
    }

    function disabledDate(current) {
        // 同时最早记录为当天的180天前，最晚记录为昨天
        return current > dayjs().subtract(1, 'days') || current < dayjs().subtract(180, 'days');
    }

    function renderFilter() {
        return (
            <>
                {type !== 'num' && (
                    <div>
                        <Input
                            style={{width: '200px'}}
                            placeholder="请输入编号"
                            onChange={changeName}
                        />
                        <Button
                            type="primary"
                            style={{margin: '0 10px'}}
                            onClick={() => initData()}
                        >
                            筛选
                        </Button>
                        <RangePicker
                            ranges={{
                                最近七天: [
                                    dayjs().subtract(8, 'days'),
                                    dayjs().subtract(1, 'days'),
                                ],
                            }}
                            disabledDate={disabledDate}
                            className={styles.rangePick}
                            onChange={changeDate}
                            defaultValue={[dayjs(start, dateFormat), dayjs(end, dateFormat)]}
                        />
                    </div>
                )}
            </>
        );
    }

    function renderTabs() {
        return (
            <Tabs onChange={changeTab} className={styles.tab} activeKey={type}>
                <TabPane tab="客户数统计" key="num">
                    <CustomerStatistic />
                </TabPane>
                {/*<TabPane tab="联系客户统计" key="customer">*/}
                {/*    <StatisticChart searchParams={searchParams} />*/}
                {/*</TabPane>*/}
                {/*<TabPane tab="群聊数据统计" key="group">*/}
                {/*    <StatisticChart searchParams={searchParams} type="group" />*/}
                {/*</TabPane>*/}
            </Tabs>
        );
    }

    return (
        <div style={{overflowY: 'auto'}}>
            <PageHeader title="客户统计" extra={renderFilter()} />
            <div className={styles.tableContainer}>{renderTabs()}</div>
        </div>
    );
}
